import { useMemo, useState } from "react";

const useAddBilling = () => {
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [rowsPerPage, setRowsPerPage] = useState(15); // Track rows per page

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "hasg",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Total",
        accessor: "total",
      },
      {
        Header: "issueddate",
        accessor: "startend time",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // sample data
  const data = [];
  // Paginate the data
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to page 1 when rows per page change
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  };
};

export default useAddBilling;
